<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>
    <template>
      <qr-edit-gateway
        v-if="showGatewayPopup"
        v-model="showGatewayPopup"
        :sections="specialInfoSingle"
        :form-data="data"
        @edit-all="handleEditAll"
        @save="qrUpdate(true)"
        @cancel="onCancel"
      >
        <template v-slot:preview style="position: relative; min-height: 100%;">
          <div class="sticky-preview">
            <v-card
              v-if="resLoading"
              class="d-flex align-center justify-center"
              flat
              min-height="50vh"
            >
              <v-progress-circular
                class="mx-auto"
                indeterminate
                size="50"
                width="5"
              />
            </v-card>
            <component
              :is="theme"
              v-else
              v-model="data"
              :order.sync="data.order"
              :components="specialInfo"
              :qr-svg-data-url="qrSvgDataUrl"

            />
          </div>
        </template>
      </qr-edit-gateway>

      <!-- فرم اصلی (هنگامی که Gateway بسته است) -->
      <v-row class="pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-card
            v-if="resLoading"
            class="d-flex align-center justify-center"
            flat
            min-height="50vh"
          >
            <v-progress-circular
              class="mx-auto"
              indeterminate
              size="50"
              width="5"
            />
          </v-card>
          <div class="sticky-preview" v-else>
            <component
              :is="theme"
              v-model="data"
              :order.sync="data.order"
              :components="specialInfo"
              :qr-svg-data-url="qrSvgDataUrl"

            />
          </div>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>وارد کردن اطلاعات محصول</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="data.visitName"
                        :disabled="e6 > 1"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام محصول شما"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-visitName`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام محصول"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        outlined
                        persistent-hint
                        readonly
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"

                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام محصول"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="mb-4 mx-4">
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize.vue";
import DownloadFile from "../qrland/downloadFile";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import NewProCard from "@/view/components/Product/newProCard";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import NewDesign from "@/view/pages/product/newDesign";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import ImageToTextInfAi from "@/view/components/adapters/AIGeneration/imageToTextInfAi.vue";
import armsChooser from "@/view/components/Product/armsChooser.vue";
import newFactoryLabel from "./components/newFactoryLabel";
import QrEditGateway from "../qrland/components/QrEditGateway.vue";
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editGoldLabel",

  components: {
    ImageToTextInfAi,
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    NewDesign,
    ThemeSelector2,
    ProductTheme2,
    NewProCard,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    armsChooser,
    newFactoryLabel,
    QrEditGateway, 
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true', 
      helpData: [],
      serviceName: "Qrland",
      componentName: "editProduct",
      data: [],
      res: [],
      resLoading: false,
      theme: "",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      picFrames: [
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: null,
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },

  watch: {
    "data.photo.gallery": {
      deep: true,
      immediate: false,
      handler(val) {
        this.$root.$emit("rerenderSwiper");
        console.log("val:", val);

        if (val[0].images.length > 0) {
          this.data.gold.img.text = true;
        } else {
          this.data.gold.img.text = false;
        }
      },
    },
    "data.video_gallery": {
      deep: true,
      immediate: true,
      handler(val) {
        const hasVideo = val?.some((item) => item.images.length > 0);
        if (this.data.gold) {
          this.data.gold.video.text = hasVideo;
        }
      },
    },
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (typeof val?.gold?.img == "boolean") {
          this.data.gold = {
            ...this.data.gold,
            img: {
              text: this.data.photo.gallery[0].images.length > 0 ? true : false,
              line: false,
            },
          };
        }

        if (typeof val?.gold?.video == "boolean") {
          const hasVideo = this.data.video_gallery.some(
            (item) => item.images.length > 0,
          );
          this.data.gold = {
            ...this.data.gold,
            video: { text: hasVideo, line: false },
          };
        }
      },
    },
  },

  provide: {
    provideSingleGallery: true,
  },

  mounted() {
    Bus.$on("colorPalette", (value) => {
      this.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.data.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.data.isGradient = value;
    });

    Bus.$on("model", (val) => {
      this.data.gold.model = {
        ...this.data.gold.model,
        source: val.value,
        name: val.title,
      };
    });

    this.fetchData();
  },

  computed: {
          specialInfo()
          { return [
          {
            name: "factoryGoldLabel",
            value: "",
            title: this.$t("edit_bpage_special_info_special.product_information"),
            subtitle: "",
            icon: "account-outline",
            model: "gold",
          },
          {
            name: "myassets",
            value: "",
            title: this.$t("edit_bpage_special_info_special.asset_management"),
            subtitle: "",
            icon: "cash-multiple",
            model: "myassets",
          },
          {
            name: "socialMediaIcons",
            value: "",
            title: this.$t("edit_bpage_special_info_special.add_social_media"),
            subtitle: "",
            icon: "instagram",
            model: "socialMedia",
            secondName: this.$t(
              "edit_bpage_special_info_special.social_media"
            ),
          },
          {
            name: "VideoGallery",
            value: "",
            title: this.$t("edit_bpage_special_info_special.add_video"),
            subtitle: "",
            icon: "video-image",
            settings: {
              notColor: true,
            },
          },
          {
            name: "imageUploader2",
            value: "",
            title: this.$t("edit_bpage_special_info_special.add_image"),
            subtitle: "",
            icon: "cloud-upload-outline",
            model: "photo",
          },
          {
            name: "colorPallete",
            value: "",
            title: this.$t("edit_bpage_special_info_special.select_color"),
            subtitle: "",
            icon: "format-color-fill",
            model: "pallete",
            secondName: "",
          },
      ]; 
      },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    specialInfoSingle() {
  return [
    {
      name: "factoryGoldLabel",
      value: "",
      title: this.$t(
        "edit_gold_special_info_single.product_info_title"
      ),
      subtitle: "",
      icon: "account-outline",
      model: "gold",
      description: this.$t(
        "edit_gold_special_info_single.product_info_description"
      ),
    },
    {
      name: "myassets",
      value: "",
      title: this.$t(
        "edit_gold_special_info_single.asset_management_title"
      ),
      subtitle: "",
      icon: "cash-multiple",
      model: "myassets",
      description: this.$t(
        "edit_gold_special_info_single.asset_management_description"
      ),
    },
    {
      name: "socialMediaIcons",
      value: "",
      title: this.$t(
        "edit_gold_special_info_single.add_social_networks_title"
      ),
      subtitle: "",
      icon: "instagram",
      model: "socialMedia",
      secondName: this.$t(
        "edit_gold_special_info_single.social_networks_title"
      ),
      description: this.$t(
        "edit_gold_special_info_single.social_media_description"
      ),
    },
    {
      name: "VideoGallery",
      value: "",
      title: this.$t(
        "edit_gold_special_info_single.add_video_title"
      ),
      subtitle: "",
      icon: "video-image",
      settings: {
        notColor: true,
      },
      description: this.$t(
        "edit_gold_special_info_single.video_description"
      ),
    },
    {
      name: "imageUploader2",
      value: "",
      title: this.$t(
        "edit_gold_special_info_single.add_image_title"
      ),
      subtitle: "",
      icon: "cloud-upload-outline",
      model: "photo",
      description: this.$t(
        "edit_gold_special_info_single.image_description"
      ),
    },
    {
      name: "colorPallete",
      value: "",
      title: this.$t(
        "edit_gold_special_info_single.select_color_title"
      ),
      subtitle: "",
      icon: "format-color-fill",
      model: "pallete",
      secondName: "",
      description: this.$t(
        "edit_gold_special_info_single.color_palette_description"
      ),
    },
  ];
},

  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },
    fetchData() {
      const fixData = (data) => {
        let fixed = { ...data.data };

        // fix video gallery
        if (!fixed.VideoGallery) {
          fixed.VideoGallery = {
            title: fixed.VideoGallerySingle?.name || "گالری ویدئو",
            description: "از ویدئوهای مجموع ما دیدن فرمایید.",
            sectionColor: {
              backGround: "",
              text: "",
            },
          };
        }

        if (!fixed.video_gallery) {
          let videos = fixed.VideoGallerySingle.videos?.map((item) => ({
            name: item.title || "خوش آمدگویی",
            title: "",
            file_link:
              item.url ||
              "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
            description: item.description,
            link: item.link,
          }));

          fixed.video_gallery = [
            {
              name: "گالری",
              images: !!videos?.length
                ? [...videos]
                : [
                    {
                      name: "خوش آمدگویی",
                      title: "",
                      file_link:
                        "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                      description: "",
                      link: "",
                      id: 15,
                    },
                  ],
            },
          ];
        }

        if (!!fixed.VideoGallerySingle) delete fixed.VideoGallerySingle;
        //
      if (!!fixed?.photo && fixed.photo.headBackground && !fixed.photo.headTransparent ){
              fixed.photo.headTransparent = false;

      }

        // fix photo
        if (!!fixed?.photo && !fixed.photo.background){
          fixed.photo.background = this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
          fixed.photo.backgroundTransparent = false;
        }
        if (!fixed.companyNumberName) fixed.companyNumberName = "";
        if (!fixed?.myassets) fixed.myassets = {};

        if (
          !fixed.gold?.more ||
          (typeof fixed.gold.more === "object" &&
            !Array.isArray(fixed.gold.more))
        ) {
          fixed.gold = {
            ...fixed.gold,
            more: [],
          };
        }

        if (fixed.gold?.myassets) {
          const { myassets, ...rest } = fixed.gold;
          fixed.gold = rest;
        }
        if (fixed.gold?.create_name) {
          const { create_name, ...rest } = fixed.gold;
          fixed.gold = rest;
        }
        if (fixed.gold?.type) {
          const { type, ...rest } = fixed.gold;
          fixed.gold = rest;
          console.log("fixed->", fixed.gold);
        }

        console.log({
          ...data,
          data: fixed,
        });

        return {
          ...data,
          data: fixed,
        };
      };

      this.loading = true;
      this.resLoading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 

          let info = fixData(data.data.data);
          this.data = info.data;
          this.theme =
            info.theme && info.theme.length > 0 ? info.theme : "newProCard";
          this.res = data.data;
        })
        .finally(() => {
          this.loading = false;
          this.resLoading = false;
        });
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      const data = new URLSearchParams();
      data.append("type", "goldlabel");
      data.append("qrType", "dynamic");
      data.append("title", this.res.title);
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);

      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.data,
        }),
      );

      this.$api
        .put("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(({ data }) => {
          this.finish = final;
          if(final || !this.AutoSave)
          this.$toast.success("لیبل طلا شما با موفقیت ویرایش شد.");
          final && this.$router.push({ name: "qr.list" });
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
